import React from 'react';
import { Link } from 'react-router-dom';
import { Phone, Mail, MessageCircle, Instagram, Facebook, Linkedin } from 'lucide-react';
import { contactInfo } from '../utils/mockData';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container mx-auto px-4">
        <div className="footer-content">
          <div className="footer-section">
            <h3 className="footer-brand">Aaron Choi</h3>
            <p className="footer-tagline">Personal Training & Wellness</p>
            <p className="footer-description">
              Transforming lives through personalized fitness programs, 
              expert guidance, and unwavering support.
            </p>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Quick Links</h4>
            <nav className="footer-links">
              <Link to="/" className="footer-link">Home</Link>
              <Link to="/services" className="footer-link">Services</Link>
              <Link to="/corporate" className="footer-link">Corporate</Link>
              <Link to="/results" className="footer-link">Results</Link>
              <Link to="/contact" className="footer-link">Contact</Link>
            </nav>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Services</h4>
            <ul className="footer-services">
              <li>Personal Training</li>
              <li>Massage Therapy</li>
              <li>Seminars & Workshops</li>
              <li>Wellness Retreats</li>
              <li>Online Coaching</li>
              <li>Nutrition Guidance</li>
            </ul>
          </div>

          <div className="footer-section">
            <h4 className="footer-title">Get In Touch</h4>
            <div className="footer-contact">
              <a href={`tel:${contactInfo.phone}`} className="footer-contact-item">
                <Phone size={18} />
                <span>{contactInfo.phone}</span>
              </a>
              <a href={`mailto:${contactInfo.email}`} className="footer-contact-item">
                <Mail size={18} />
                <span>{contactInfo.email}</span>
              </a>
              <a 
                href={`https://wa.me/${contactInfo.whatsapp.replace(/\+/g, '')}`}
                target="_blank"
                rel="noopener noreferrer"
                className="footer-contact-item"
              >
                <MessageCircle size={18} />
                <span>WhatsApp</span>
              </a>
            </div>

            <div className="footer-social">
              <a href="#" className="social-link" aria-label="Instagram">
                <Instagram size={20} />
              </a>
              <a href="#" className="social-link" aria-label="Facebook">
                <Facebook size={20} />
              </a>
              <a href="#" className="social-link" aria-label="LinkedIn">
                <Linkedin size={20} />
              </a>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            © {currentYear} Aaron Choi Personal Training. All rights reserved.
          </p>
          <div className="footer-bottom-links">
            <button className="footer-bottom-link">Privacy Policy</button>
            <button className="footer-bottom-link">Terms of Service</button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
